import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import {
  StatusContainer,
  StatusContent,
  StatusMessage,
  StatusTitle,
} from './status.styled'
import { ReactComponent as ExpiredIcon } from '../../assets/link_expired.svg'
import { ReactComponent as NotAvailableIcon } from '../../assets/link_not_available.svg'
import { ReactComponent as UsedIcon } from '../../assets/link_used.svg'
import { ReactComponent as ErrorIcon } from '../../assets/error.svg'
import { ReactComponent as InactiveIcon } from '../../assets/link_inactive.svg'

export const StatusExpired: FC = () => {
  const { t } = useTranslation()

  return (
    <StatusContainer>
      <StatusContent>
        <ExpiredIcon />
        <StatusTitle>{t('Link expired')}</StatusTitle>
        <StatusMessage>
          {t('Your payment link has expired. If necessary, please contact us.')}
        </StatusMessage>
      </StatusContent>
    </StatusContainer>
  )
}

export const StatusCanceled: FC = () => {
  const { t } = useTranslation()

  return <StatusContainer>
    <StatusContent>
      <NotAvailableIcon />
      <StatusTitle>{t('Link canceled')}</StatusTitle>
      <StatusMessage>
        {t('It seems that this link has already been canceled. If necessary, please contact us')}
      </StatusMessage>
    </StatusContent>
  </StatusContainer>
}

export const StatusUsed: FC = () => {
  const { t } = useTranslation()

  return <StatusContainer>
    <StatusContent>
      <UsedIcon />
      <StatusTitle>{t('Link used')}</StatusTitle>
      <StatusMessage>
        {t('It seems that this link has already been used. If necessary, please contact us')}
      </StatusMessage>
    </StatusContent>
  </StatusContainer>
}

export const StatusError: FC = () => {
  const { t } = useTranslation()

  return <StatusContainer>
    <StatusContent>
      <ErrorIcon />
      <StatusTitle>
        {t('Ooops!, something went wrong')}
      </StatusTitle>
      <StatusMessage>
        {t('Please try again in a few minutes. If the problem persists, please contact us')}
      </StatusMessage>
    </StatusContent>
  </StatusContainer>
}

export const StatusInactive: FC = () => {
  const { t } = useTranslation()

  return <StatusContainer>
    <StatusContent>
      <InactiveIcon />
      <StatusTitle>
        {t('Ooops!')}
      </StatusTitle>
      <StatusMessage>
        {t('Looks like the payment link you tapped on isn\'t active anymore.')}
      </StatusMessage>
    </StatusContent>
  </StatusContainer>
}
